module.exports = __webpack_public_path__ + "img/TraumIV.5b22a23f.jpg";